import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";

import { apiSlice, authSliceReducer, playFilterSliceReducer, sportSliceReducer, themeSliceReducer } from "./slices";

const initialState = {};

export const store = configureStore({
  reducer: {
    auth: authSliceReducer,
    theme: themeSliceReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    sport: sportSliceReducer,
    playFilter: playFilterSliceReducer,
  },
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(apiSlice.middleware),
});

setupListeners(store.dispatch);

// Infer the RootState and AppDispatch types from the store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
